export enum RatingSubject {
    QUEST_SOLUTION_CODE_QUALITY = 'quest_solution_code_quality',
    QUEST_SOLUTION_MATCH_REQUIREMENTS = 'quest_solution_match_requirements',
    QUEST_DESCRIPTION = 'quest_description',
    WORK_DESCRIPTION = 'work_description',
    WORK_SOLUTION_MATCH_REQUIREMENTS = 'work_solution_match_requirements',
    WORK_SOLUTION_CODE_QUALITY = 'work_solution_code_quality',
    WORK_REVIEW_QA_FUNCTIONALITY = 'work_review_qa_functionality',
    WORK_REVIEW_CODE_QUALITY = 'work_review_code_quality'
}
